import { useMemo } from "react";
import { usePortfolio } from "@/hooks/usePortfolio";
import { useDepartments } from "@/hooks/useDepartments";

/** Every department name: the departments list (Admin) plus any value
 *  still sitting on a project, so nothing disappears from a dropdown.
 *  The same source feeds the Departments tiles and every department
 *  picker. */
export function useDepartmentNames(): string[] {
  const { data } = usePortfolio(false);
  const depts = useDepartments();
  return useMemo(() => {
    const names = new Set<string>();
    for (const d of depts.data ?? []) names.add(d.name);
    const list = Array.isArray(data) ? data : [];
    for (const p of list) {
      const d = (p.department ?? "").trim();
      if (d) names.add(d);
    }
    return Array.from(names).sort((a, b) => a.localeCompare(b));
  }, [data, depts.data]);
}
